import { CREATE, LIST, DETAIL, DELETE, UPDATE, TOOGLE_STATUS, UPDATE_JOB, UPDATE_NOTES } from '@/api/modules/dataLinkMulti.api';

export default {
    create({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CREATE({ payload }, successCallback, errorCallback);
    },

    list({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        LIST({ payload }, successCallback, errorCallback);
    },

    detail({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DETAIL({ payload }, successCallback, errorCallback);
    },

    delete({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DELETE({ payload }, successCallback, errorCallback);
    },

    update({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE({ payload }, successCallback, errorCallback);
    },

    updateNotes({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_NOTES({ payload }, successCallback, errorCallback);
    },

    toogle_status({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        TOOGLE_STATUS({ payload }, successCallback, errorCallback);
    },

    update_job({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_JOB({ payload }, successCallback, errorCallback);
    }
};
